import type { IconVariants } from 'core/generic/elements/icons';

export type FeatureCardProps = {
	title: string;
	description?: string;
	icon: IconVariants;
	url: string;
	isVisibleApp: boolean;
	target?: '_blank' | '_self';
};

export const featuresList: FeatureCardProps[] = [
	{
		title: 'Tickets',
		description: 'Manage your match tickets and tours',
		url: `https://tickets.mancity.com/crmdetails.aspx`,
		target: '_blank',
		icon: 'Ticket',
		isVisibleApp: true,
	},
	{
		title: 'Shop',
		description: 'Manchester City Official Store with products in all sizes',
		url: `https://shop.mancity.com/gb/en/account/show/`,
		target: '_blank',
		icon: 'ShoppingBag',
		isVisibleApp: true,
	},
	{
		title: 'Personal Details',
		description: 'Edit and verify your personal details',
		url: `/personal-details`,
		target: '_self',
		icon: 'User',
		isVisibleApp: true,
	},
	{
		title: 'Preferences',
		description: 'Manage your marketing preferences',
		url: `/preferences`,
		target: '_self',
		icon: 'Mail',
		isVisibleApp: true,
	},
	{
		title: 'Subscriptions',
		description: 'Manage your CITY+ and coaching subscriptions',
		url: `/subscriptions`,
		target: '_self',
		icon: 'DeviceTv',
		isVisibleApp: false,
	},
	{
		title: 'Official Supporters Clubs ',
		description: 'Find your official supporters club',
		url: `/official-supporters-clubs`,
		target: '_self',
		icon: 'UserGroup',
		isVisibleApp: false,
	}
];
